import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LocalizacaoEstoqueRequest } from '../../requests/produto/localizacao-estoque.request';
import { GetLocalizacaoEstoqueResponse } from '../../responses/produto/get-localizacao-estoque.response';
import { CreateLocalizacaoEstoqueResponse } from '../../responses/produto/create-localizacao-estoque.response';
import { LocalizacaoEstoqueBulkActionResponse } from '../../responses/produto/localizacao-estoque-bulk-action.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class LocalizacaoEstoqueService extends CommonService {
    private readonly apiUrl = `${environment.urlApiProduto}LocalizacaoEstoque`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(pesquisa: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetLocalizacaoEstoqueResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (pesquisa) {
            params = params.set('pesquisa', pesquisa);
        }

        return this.httpClient
            .get<GetLocalizacaoEstoqueResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(idLocalizacaoEstoque: number): Observable<GetLocalizacaoEstoqueResponse> {
        const url = `${this.apiUrl}/${idLocalizacaoEstoque}`;
        return this.httpClient
            .get<GetLocalizacaoEstoqueResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: LocalizacaoEstoqueRequest): Observable<CreateLocalizacaoEstoqueResponse> {
        return this.httpClient
            .post<CreateLocalizacaoEstoqueResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(idLocalizacaoEstoque: number, request: LocalizacaoEstoqueRequest): Observable<CreateLocalizacaoEstoqueResponse> {
        const url = `${this.apiUrl}/${idLocalizacaoEstoque}`;
        return this.httpClient
            .put<CreateLocalizacaoEstoqueResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(idLocalizacaoEstoque: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idLocalizacaoEstoque}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(idsLocalizacaoEstoque: number[]): Observable<LocalizacaoEstoqueBulkActionResponse> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<LocalizacaoEstoqueBulkActionResponse>(url, { idsLocalizacaoEstoque }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public inactivateBulk(idsLocalizacaoEstoque: number[]): Observable<LocalizacaoEstoqueBulkActionResponse> {
        const url = `${this.apiUrl}/bulk-inactivate`;
        return this.httpClient
            .post<LocalizacaoEstoqueBulkActionResponse>(url, { idsLocalizacaoEstoque }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public setDefault(idLocalizacaoEstoque: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idLocalizacaoEstoque}/set-default`;
        return this.httpClient
            .post<ReturnStruct>(url, {}, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public setAtivo(idLocalizacaoEstoque: number, isAtivo: boolean): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idLocalizacaoEstoque}/set-ativo`;
        return this.httpClient
            .post<ReturnStruct>(url, { isAtivo }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
